module.exports = __webpack_public_path__ + "img/user_head.33d2a79c.png";